<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div class="standing-data">
        @if (sdConfig) {
            <div class="main-body standing-data-content">
                @if (sdConfig.hasCustomComponent) {
                    <ng-container
                        #customComponentContainer
                        [ngComponentOutlet]="sdConfig.customComponent?.component"
                        [ngComponentOutletInputs]="sdConfig.customComponent?.inputs"
                        [ngComponentOutletInjector]="sdConfig.customComponent?.injector"
                    ></ng-container>
                } @else {
                    <standingdata-generic
                        [type]="selectedPage.ID"
                        [name]="selectedPage.Name"
                        #genericSD
                    ></standingdata-generic>
                }
            </div>
        } @else {
            @if (selectedPage) {
                <div class="main-body standing-data-loading">
                    <div class="fancy-loader submodule"></div>
                </div>
            } @else {
                <div class="main-body standing-data-unselected">
                    <span>{{ "overview.unselectedMessage" | t }}</span>
                </div>
            }
        }
    </div>
}

<ng-template #customMenu>
    @for (node of allowedPages; track node) {
        <ng-container
            *ngTemplateOutlet="nodeTemplate; context: { node: node, parent: null, depth: 0 }"
        >
        </ng-container>
    }
</ng-template>

<ng-template #nodeTemplate let-node="node" let-parent="parent" let-depth="depth">
    <div class="node" [class.selected]="selectedPage && node.ID === selectedPage.ID" data-uiid="">
        <div class="node-detail" [title]="node.Name">
            <div class="node-child-toggler">
                @if (node.Children.length > 0) {
                    <i
                        class="fas fa-angle-{{ node.isExpanded ? 'down' : 'right' }}"
                        (click)="node.isExpanded = !node.isExpanded"
                    ></i>
                }
            </div>
            <div class="node-icon" (click)="nodeClicked(node)">
                <cerrix-icon-viewer [icon]="node.Icon" appendClass="fa-fw"></cerrix-icon-viewer>
            </div>
            <div
                class="node-name"
                (click)="nodeClicked(node)"
                [attr.data-uiid]="'tabmenu-item-' + (parent ? parent.Name + '-' : '') + node.Name"
            >
                {{ node.Name }}
            </div>
        </div>
        @if (node.isExpanded && node.Children.length > 0) {
            <div class="children">
                @for (child of node.Children; track child) {
                    <ng-container
                        *ngTemplateOutlet="
                            nodeTemplate;
                            context: { node: child, parent: node, depth: depth + 1 }
                        "
                    >
                    </ng-container>
                }
            </div>
        }
    </div>
</ng-template>
